/**
 * Effi Home product page behaviour.
 * - Variant switching (finish, pack size, hook style, any other option)
 * - Updates price, pack cards (per unit price and savings), add to cart button,
 *   sticky bar, hidden variant id, gallery image and the URL
 * - Thumbnails, quantity stepper, mobile sticky add to cart bar
 * Adding to cart is left to Horizon's product-form-component.
 */
(function () {
'use strict';

/** Formats cents with Shopify's money format string, for example "${{amount}}" */
function formatMoney(cents, format, currency) {
  var precision = ['JPY', 'KRW', 'VND', 'CLP', 'ISK', 'HUF'].indexOf((currency || '').toUpperCase()) >= 0 ? 0 : 2;
  var amount = (cents / Math.pow(10, precision)).toFixed(precision);
  var parts = amount.split('.');
  var whole = parts[0].replace(/\d(?=(\d{3})+$)/g, '$&,');
  var out = (format || '${{amount}}').replace(/<[^>]*>/g, '');
  return out.replace(/{{\s*(\w+)\s*}}/g, function (_, key) {
    switch (key) {
      case 'amount_no_decimals': return whole;
      case 'amount_with_comma_separator': return parts[0].replace(/\d(?=(\d{3})+$)/g, '$&.') + (precision ? ',' + parts[1] : '');
      case 'amount_no_decimals_with_comma_separator': return parts[0].replace(/\d(?=(\d{3})+$)/g, '$&.');
      case 'amount_with_space_separator': return parts[0].replace(/\d(?=(\d{3})+$)/g, '$& ') + (precision ? ',' + parts[1] : '');
      case 'amount_no_decimals_with_space_separator': return parts[0].replace(/\d(?=(\d{3})+$)/g, '$& ');
      case 'currency': return currency || '';
      default: return whole + (precision ? '.' + parts[1] : '');
    }
  });
}

var ready = function (fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); };

class EffiProductPage {
  constructor(root) {
    this.root = root;
    const d = root.dataset;
    this.finishIndex = parseInt(d.finishIndex, 10);
    this.packIndex = parseInt(d.packIndex, 10);
    this.styleIndex = parseInt(d.styleIndex, 10);
    this.unit = d.unit || 'hook';
    this.moneyFormat = d.moneyFormat || '${{amount}}';
    this.currency = d.currency || 'AUD';
    this.atcLabel = d.atcLabel || 'Add to cart';
    this.unavailableLabel = d.unavailableLabel || 'Sold out';
    this.packFormat = d.packFormat || 'auto';
    this.bestseller = (d.bestseller || '').split(',').map((s) => s.trim()).filter(Boolean);
    this.bestvalue = (d.bestvalue || '').split(',').map((s) => s.trim()).filter(Boolean);

    try {
      this.variants = JSON.parse(root.querySelector('[data-effi-variants]').textContent);
    } catch (e) {
      this.variants = [];
      console.warn('[effi-product] Could not read variant data', e);
    }
    try {
      this.selected = JSON.parse(d.selected || '[]');
    } catch (e) {
      this.selected = [];
    }
    try {
      var mediaEl = root.querySelector('[data-effi-media]');
      this.media = mediaEl ? JSON.parse(mediaEl.textContent) : [];
    } catch (e) {
      this.media = [];
    }
    this.visibleMedia = null;

    this.form = root.querySelector('form[data-type="add-to-cart-form"]');
    this.variantInput = root.querySelector('[data-variant-id]');
    this.priceEl = root.querySelector('[data-price]');
    this.atcButton = root.querySelector('[data-atc]');
    this.atcTexts = root.querySelectorAll('[data-atc-text]');
    this.qtyInput = root.querySelector('[data-qty-input]');
    this.sticky = root.querySelector('[data-sticky]');
    this.stickyVariant = root.querySelector('[data-sticky-variant]');
    this.stickyButton = root.querySelector('[data-sticky-atc]');
    this.stage = root.querySelector('.effi-pdp__stage');

    this.bindOptions();
    this.bindQuantity();
    this.bindGallery();
    this.bindSticky();
    if (this.variants.length) this.update(false);

    document.addEventListener('effi:select-option', (e) => this.selectByValue(e.detail && e.detail.value));    this.bindReviewsLink();

  }

    /** Stars line: scroll down to the Judge.me reviews (or any reviews section) on the page */
  bindReviewsLink() {
    const link = this.root.querySelector('[data-effi-reviews-link]');
    if (!link) return;
    link.addEventListener('click', (e) => {
      // Judge.me first, then any other reviews section on the page
      const selectors = ['#judgeme_product_reviews', '.jdgm-rev-widg', '.jdgm-review-widget', '.jdgm-widget', '#effi-reviews', '.effi-reviews'];
      let target = null;
      for (const sel of selectors) {
        target = document.querySelector(sel);
        if (target) break;
      }      if (!target) return;
      e.preventDefault();
      // scrollIntoView works on desktop too, where Horizon scrolls the page inside a wrapper
      target.style.scrollMarginTop = '80px';
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });    });
  }
money(cents) {
    return formatMoney(cents, this.moneyFormat, this.currency);
  }

  /* ---------- options ---------- */
  bindOptions() {
    this.root.querySelectorAll('.effi-opt input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => {
        const pos = parseInt(input.closest('.effi-opt').dataset.optionPosition, 10);
        this.selected[pos] = input.value;
        this.update(true);
      });
    });
  }

  selectByValue(value) {
    if (!value) return;
    const input = Array.from(this.root.querySelectorAll('.effi-opt input[type="radio"]')).find(
      (i) => i.value.toLowerCase() === String(value).toLowerCase()
    );
    if (!input) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  matches(variant, selection, ignoreIndex) {
    return variant.options.every((opt, i) => i === ignoreIndex || selection[i] === undefined || opt === selection[i]);
  }

  currentVariant() {
    return this.variants.find((v) => this.matches(v, this.selected, -1)) || null;
  }

  unitsFor(value) {
    const n = parseInt(String(value).trim(), 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  /** Display name for an option value: text before any "|" (so "3 Hooks | $64.99 | BEST SELLER" shows as "3 Hooks") */
  clean(value) {
    return String(value).split('|')[0].trim();
  }

  /** Display name for a pack value, tidy ("3 pack") or as written */
  packName(value) {
    if (this.packFormat !== 'auto') return this.clean(value);
    const units = this.unitsFor(value);
    return units === 1 ? 'Single' : `${units} pack`;
  }

  displayName(pos, value) {
    return pos === this.packIndex ? this.packName(value) : this.clean(value);
  }

  /* ---------- update everything ---------- */
  /* Fallback when variant data is unavailable: copy the selected pack card's price into the buttons */
  mirrorSelection() {
    var checked = this.root.querySelector('[data-pack] input:checked');
    var card = checked && checked.closest('[data-pack]');
    var price = card && card.querySelector('[data-pack-price]');
    if (price && price.textContent.trim() && price.textContent.trim() !== '—') {
      var text = this.atcLabel + ' ' + price.textContent.trim();
      this.atcTexts.forEach(function (el) { el.textContent = text; });
    }
    if (this.stickyVariant) {
      var names = [];
      var self = this;
      this.root.querySelectorAll('.effi-opt').forEach(function (group) {
        var input = group.querySelector('input:checked');
        if (input) names.push(self.displayName(parseInt(group.dataset.optionPosition, 10), input.value));
      });
      if (names.length) this.stickyVariant.textContent = names.join(' · ');
    }
  }

  update(userAction) {
    if (!this.variants.length) { this.mirrorSelection(); return; }
    const variant = this.currentVariant();
    const qty = this.quantity();

    // Option labels ("Finish: Jet Black")
    this.root.querySelectorAll('[data-option-label]').forEach((el) => {
      const pos = parseInt(el.dataset.optionLabel, 10);
      if (this.selected[pos] !== undefined) el.textContent = this.displayName(pos, this.selected[pos]);
    });

    // Price
    if (this.priceEl) this.priceEl.textContent = variant ? this.money(variant.price) : '';    const compareEl = this.root.querySelector('[data-compare-price]');
    if (compareEl) { const was = variant && variant.compare > variant.price ? variant.compare : 0; compareEl.textContent = was ? this.money(was) : ''; compareEl.hidden = !was; }

    // Hidden id + button
    if (this.variantInput && variant) this.variantInput.value = variant.id;
    const available = !!(variant && variant.available);
    const text = available ? `${this.atcLabel} ${this.money(variant.price * qty)}` : this.unavailableLabel;
    this.atcTexts.forEach((el) => (el.textContent = text));
    if (this.atcButton) this.atcButton.disabled = !available;
    if (this.stickyButton) this.stickyButton.disabled = !available;
    if (this.stickyVariant && this.selected.length) {
      this.stickyVariant.textContent = this.selected.map((v, i) => this.displayName(i, v)).join(' · ');
    }

    const atcWrap = this.root.querySelector('[ref="addToCartButtonContainer"]');
    if (atcWrap && variant && variant.thumb) atcWrap.setAttribute('data-product-variant-media', variant.thumb);

    this.updatePacks();
    const meta = this.root.querySelector('[data-price-meta]'); const packIn = this.root.querySelector('[data-pack] input:checked'); if (meta && packIn) { const save = packIn.closest('[data-pack]').querySelector('[data-pack-save]'); meta.textContent = save ? save.textContent.trim() : ''; }    this.updateAvailability();    this.updateStyleImages();

    // Gallery: show only this colour's photos, then jump to its main photo
    this.applyGallery();
    if (variant && variant.media && userAction) {
      this.showMedia(String(variant.media));
    } else if (this.visibleMedia && this.stage) {
      const activeSlide = this.stage.querySelector('.effi-pdp__slide.is-active');
      if (!activeSlide || this.visibleMedia.indexOf(activeSlide.dataset.mediaId) < 0) this.showMedia(this.visibleMedia[0]);
    }

    // URL
    if (variant && userAction && window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  updatePacks() {
    if (this.packIndex < 0) return;
    const cards = Array.from(this.root.querySelectorAll('[data-pack]'));
    if (!cards.length) return;

    const rows = cards.map((card) => {
      const value = card.querySelector('input').value;
      const sel = this.selected.slice();
      sel[this.packIndex] = value;
      const v = this.variants.find((x) => this.matches(x, sel, -1)) || null;
      return { card, value, units: this.unitsFor(value), variant: v };
    });

    // Base "per unit" price comes from the smallest pack that exists for this selection
    let base = null;
    rows.forEach((r) => {
      if (r.variant && (base === null || r.units < base.units)) base = r;
    });
    const baseUnit = base ? base.variant.price / base.units : 0;

    rows.forEach((r) => {
      const priceEl = r.card.querySelector('[data-pack-price]');
      const unitEl = r.card.querySelector('[data-pack-unit]');
      const saveEl = r.card.querySelector('[data-pack-save]');
            const wasEl = r.card.querySelector('[data-pack-was]'); if (wasEl) wasEl.textContent = r.variant && r.variant.compare > r.variant.price ? this.money(r.variant.compare) : '';
      const input = r.card.querySelector('input');
      const unavailable = !r.variant || !r.variant.available;
      r.card.classList.toggle('is-unavailable', unavailable);
      input.disabled = !r.variant;
      if (!r.variant) {
        priceEl.textContent = '—';
        unitEl.textContent = '';
        saveEl.textContent = '';
        return;
      }
      priceEl.textContent = this.money(r.variant.price);
      unitEl.textContent = `${this.money(Math.round(r.variant.price / r.units))} per ${this.unit}`;
      const saving = Math.round(baseUnit * r.units - r.variant.price);
      saveEl.textContent = saving > 0 ? `Save ${this.money(saving)}` : '';
    });
  }

    /** Hook style cards: swap to the "second colour" photos when that colour is selected */
  updateStyleImages() {
    const alt = String(this.root.dataset.styleAltFinish || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
    const current = this.finishIndex >= 0 ? String(this.selected[this.finishIndex] || '').toLowerCase().replace(/[^a-z0-9]+/g, '') : '';
    const on = !!alt && current === alt;
    this.root.querySelectorAll('.effi-styles').forEach((el) => el.classList.toggle('is-alt', on));
  }
updateAvailability() {
    // Grey out finish swatches / style cards that have no available variant for the other choices (any pack size)
    this.root.querySelectorAll('.effi-opt--swatch, .effi-opt--style, .effi-opt--pill').forEach((group) => {
      const pos = parseInt(group.dataset.optionPosition, 10);
      group.querySelectorAll('label').forEach((label) => {
        const input = label.querySelector('input');
        const sel = this.selected.slice();
        sel[pos] = input.value;
        const ok = this.variants.some((v) => v.available && this.matches(v, sel, this.packIndex));
        label.classList.toggle('is-unavailable', !ok);
      });
    });
  }

  /* ---------- quantity ---------- */
  quantity() {
    const n = parseInt(this.qtyInput && this.qtyInput.value, 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  bindQuantity() {
    const wrap = this.root.querySelector('[data-qty]');
    if (!wrap || !this.qtyInput) return;
    wrap.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      const next = Math.max(1, this.quantity() + parseInt(btn.dataset.qtyStep, 10));
      this.qtyInput.value = String(next);
      this.update(false);
    });
    this.qtyInput.addEventListener('change', () => {
      this.qtyInput.value = String(this.quantity());
      this.update(false);
    });
  }

  /* ---------- gallery ---------- */
  bindGallery() {
    this.thumbOrder = Array.from(this.root.querySelectorAll('[data-thumb-for]'));
    this.thumbOrder.forEach((thumb) => {
      thumb.addEventListener('click', () => this.showMedia(thumb.dataset.thumbFor));
    });
  }

  /**
   * Works out which photos belong to the selected variant.
   * 1. A "main" photo is any photo Shopify links to a variant (each colour of a
   *    hook, or each colour and hook style of a set).
   * 2. Photo order: a main photo's set is itself plus every photo after it, up
   *    to the next main photo. So keep each variant's extra shots right after
   *    its main photo in the admin.
   * 3. Photos before the first main photo are shared, unless their alt text or
   *    file name contains a colour name, in which case they join that colour.
   * 4. A variant with only its main photo shows just that photo. A colour with no
   *    photo at all shows everything.
   */
  applyGallery() {
    if (!this.stage || !(this.finishIndex >= 0) || !this.media || !this.media.length) return;
    const norm = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
    const value = this.selected[this.finishIndex];
    if (value === undefined) return;

    // Main photo per colour (first variant of that colour with a photo) and per variant
    const mains = {};
    const variantMains = {};
    this.variants.forEach((v) => {
      if (!v.media) return;
      const id = String(v.media);
      const val = v.options[this.finishIndex];
      if (mains[val] === undefined) mains[val] = id;
      variantMains[id] = true;
    });
    if (!mains[value]) {
      this.setThumbs(null);
      return;
    }
    const colours = Object.keys(mains).sort((a, b) => norm(b).length - norm(a).length);

    // Walk the photos in order
    const byMain = {};
    const colourExtra = {};
    const shared = [];
    let currentMain = null;
    this.media.forEach((m) => {
      const id = String(m.id);
      if (variantMains[id]) currentMain = id;
      if (currentMain) {
        (byMain[currentMain] = byMain[currentMain] || []).push(id);
        return;
      }
      const hay = norm(m.alt) + ' ' + norm(m.file);
      const hit = colours.find((c) => norm(c) && hay.indexOf(norm(c)) >= 0);
      if (hit) (colourExtra[hit] = colourExtra[hit] || []).push(id);
      else shared.push(id);
    });

    const variant = this.currentVariant();
    const first = variant && variant.media && variantMains[String(variant.media)] ? String(variant.media) : mains[value];
    const extra = colourExtra[value] || [];

    // The variant's own photo, then the photos filed after it, then any shared photos.
    // A variant with only its own photo shows just that photo (the thumbnail row hides).
    this.setThumbs([first].concat((byMain[first] || []).filter((id) => id !== first), extra, shared));
  }

  setThumbs(visible) {
    const wrap = this.root.querySelector('.effi-pdp__thumbs');
    this.visibleMedia = visible;
    if (!wrap) return;
    const thumbs = Array.from(wrap.querySelectorAll('[data-thumb-for]'));
    if (!visible) {
      (this.thumbOrder || thumbs).forEach((t) => { t.hidden = false; wrap.appendChild(t); });
      wrap.hidden = thumbs.length < 2;
      return;
    }
    thumbs.forEach((t) => { t.hidden = visible.indexOf(t.dataset.thumbFor) < 0; });
    visible.forEach((id) => {
      const t = thumbs.find((x) => x.dataset.thumbFor === id);
      if (t) wrap.appendChild(t);
    });
    wrap.hidden = visible.length < 2;
  }

  showMedia(id) {
    if (!this.stage) return;
    let found = false;
    this.stage.querySelectorAll('.effi-pdp__slide').forEach((slide) => {
      const active = slide.dataset.mediaId === id;
      slide.classList.toggle('is-active', active);
      if (active) found = true;
      if (!active) {
        const video = slide.querySelector('video');
        if (video) video.pause();
      }
    });
    if (!found) return;    // Badge pill only on the main photo of the selected colour or style
    const mainId = this.visibleMedia ? this.visibleMedia[0] : (this.thumbOrder && this.thumbOrder[0] ? this.thumbOrder[0].dataset.thumbFor : id);
    this.stage.classList.toggle('is-main', id === mainId);
    this.root.querySelectorAll('[data-thumb-for]').forEach((thumb) => {
      const active = thumb.dataset.thumbFor === id;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active && thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  /* ---------- sticky bar (mobile) ---------- */
  bindSticky() {
    if (!this.sticky || !this.atcButton) return;
    const mq = window.matchMedia('(max-width: 959px)');
    let mainButtonVisible = true;
    let pastButton = false;

    const apply = () => {
      const show = mq.matches && !mainButtonVisible && pastButton;
      this.sticky.classList.toggle('is-visible', show);
      this.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('effi-sticky-space', show);
    };

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            mainButtonVisible = entry.isIntersecting;
            pastButton = entry.boundingClientRect.top < 0;
          });
          apply();
        },
        { threshold: 0 }
      );
      io.observe(this.atcButton);
    }
    mq.addEventListener('change', apply);

    this.stickyButton.addEventListener('click', () => {
      if (!this.form) return;
      if (this.form.requestSubmit) this.form.requestSubmit();
      else this.form.submit();
    });
  }
}

function init(root) {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  try {
    new EffiProductPage(root);
  } catch (e) {
    console.warn('[effi-product] Failed to start', e);
  }
}

ready(function () {
  document.querySelectorAll('.effi-pdp').forEach(init);
});

// Theme editor re-renders the section: initialise again
document.addEventListener('shopify:section:load', function (e) {
  var root = e.target && e.target.querySelector && e.target.querySelector('.effi-pdp');
  init(root);
});

})();